import { SET_SELECTED_NODE } from "constants/app";

export default (state = null, action) => {
  switch (action.type) {
    case SET_SELECTED_NODE:
      return action.value;
    default:
      return state;
  }
};
